import { Table } from "antd";
import moment from "moment";
import { usePreEmploymentRequirements } from "../../../app/hooks/usePreEmploymentRequirements";
import NotifyButton from "./buttons/NotifyButton";

const Documents = () => {
  const { data, isLoading } = usePreEmploymentRequirements();

  const columns = [
    {
      title: "Date",
      dataIndex: "submittedAt",
      key: "submittedAt",
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "—",
    },
    {
      title: "Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Documents For Compliance",
      dataIndex: "documentName",
      key: "documentName",
    },
    {
      title: "Status",
      dataIndex: "requirementStatus",
      key: "requirementStatus",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <NotifyButton disabled={!record.canNotify} />
      ),
    },
  ];

  return (
    <div
      style={{
        width: "1240px",
        margin: "20px",
        padding: "0 30px 30px 30px",
        backgroundColor: "#EFEEEE",
        borderRadius: "20px",
        border: "4px solid #e6e6e6",
      }}
    >
      <Table
        pagination={false}
        dataSource={data}
        columns={columns}
        rowKey="id"
        loading={isLoading}
        title={() => <h2 style={{ textAlign: "center" }}>Documents</h2>}
      />
    </div>
  );
};

export default Documents;
